import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  scroll(e) {
    e.preventDefault();

    $.easing.quart = function (x, t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    };

    var speed = 1200,
      href = $(e.currentTarget).attr("href"),
      target = $(href == "#" || href == "" ? "html" : href),
      position = target.offset().top,
      y_position = window.scrollY;

    if (position == y_position) {
      return false;
    } else {
      $("html, body").animate(
        {
          scrollTop: position,
        },
        speed,
        "quart",
      );
    }
  }
}
